import { useEffect, useState } from "react";
import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";

const ConnectionLostOverlay = ({ hasInternet }: { hasInternet: boolean }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (!hasInternet) {
      setShowOverlay(true);
    } else {
      setTimeout(() => {
        setShowOverlay(false);
      }, 1000);
    }
  }, [hasInternet]);

  return showOverlay ? (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.65)",
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "1rem",
          padding: "2rem",
          maxWidth: "90vw",
          width: 350,
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
          textAlign: "center",
        }}
      >
        {!hasInternet ? (
          <LoadingOutlined style={{ fontSize: 48, color: "#fa541c" }} spin />
        ) : (
          <CheckCircleOutlined style={{ fontSize: 48, color: "#52c41a" }} />
        )}
        <h2 style={{ marginTop: "1rem", fontWeight: 600, fontSize: "1.25rem" }}>
          Connection {!hasInternet ? "Lost" : "Restored"}
        </h2>
        <p style={{ color: "#888", margin: "0.5rem 0 0" }}>
          {!hasInternet && "Please check your internet connection."}
        </p>
      </div>

      <style>
        {`
            @media (max-width: 480px) {
              h2 {
                font-size: 1rem !important;
              }

              p {
                font-size: 0.875rem !important;
              }
            }
          `}
      </style>
    </div>
  ) : (
    <></>
  );
};

export default ConnectionLostOverlay;
